import {
  getOddValue,
  resolveOddsTrend,
  formatOddsByBookmarkerExtend,
} from "@/utils/matchInfo";

export function formatOddsValueForBookmaker(rawValue, bookmarkerExtend) {
  return formatOddsByBookmarkerExtend(rawValue, bookmarkerExtend);
}

export function cellText(v) {
  if (v === null || v === undefined || v === "") return "-";
  return String(v);
}

const GROUP_LIVE = 0;
const GROUP_TL = 1;
const GROUP_EARLY = 2;

const CELL_LEFT = 0;
const CELL_CENTER = 1;
const CELL_RIGHT = 2;

export function tdBorderRightAfterThirdColumn(groupIndex, cellIndex) {
  return groupIndex < GROUP_EARLY && cellIndex === CELL_RIGHT;
}

export function trendForHandicapOrOverUnder(trends, groupIndex, cellIndex) {
  if (cellIndex === CELL_CENTER) {
    return "unchanged";
  }
  if (groupIndex === GROUP_EARLY) {
    return "unchanged";
  }
  if (groupIndex === GROUP_LIVE) {
    return cellIndex === CELL_LEFT ? trends.liveLeftTrend : trends.liveRightTrend;
  }
  if (groupIndex === GROUP_TL) {
    return cellIndex === CELL_LEFT ? trends.compareLeftTrend : trends.compareRightTrend;
  }
  return "unchanged";
}

export function trendForOneXTwo(trends, groupIndex, cellIndex) {
  if (groupIndex === GROUP_EARLY) {
    return "unchanged";
  }
  if (groupIndex === GROUP_LIVE) {
    return [trends.liveHomeTrend, trends.liveDrawTrend, trends.liveAwayTrend][cellIndex];
  }
  if (groupIndex === GROUP_TL) {
    return [trends.compareHomeTrend, trends.compareDrawTrend, trends.compareAwayTrend][cellIndex];
  }
  return "unchanged";
}

function referenceRows(match, isAll) {
  if (!isAll) {
    return { hdp: null, ou: null, eu: null, hdpHt: null, ouHt: null, euHt: null };
  }
  return {
    hdp: match?.handicapOdds?.[0],
    ou: match?.overUnderOdds?.[0] || match?.odd?.overUnderOdds?.[0],
    eu: match?.europeOdds?.[0],
    hdpHt: match?.handicapHalfOdds?.[0],
    ouHt: match?.overUnderHalfOdds?.[0],
    euHt: match?.europeHalfOdds?.[0] || match?.odd?.europeHalfOdds?.[0],
  };
}

function handicapBlock(row, ref, format, isHalf, hook) {
  const live = [
    format(row?.instantHome),
    getOddValue(row?.instantHandicap, null),
    format(row?.instantAway),
  ];

  let compare;
  let early;
  if (isHalf) {
    compare = [
      format(getOddValue(row?.instantHome, ref?.instantHome ?? ref?.initialHome)),
      getOddValue(row?.instantHandicap, ref?.instantHandicap ?? ref?.initialHandicap),
      format(getOddValue(row?.instantAway, ref?.instantAway ?? ref?.initialAway)),
    ];
    early = [
      format(getOddValue(row?.initialHome, ref?.initialHome)),
      getOddValue(row?.instantHandicap, ref?.initialHandicap),
      format(getOddValue(row?.initialAway, ref?.initialAway)),
    ];
  } else {
    compare = [
      format(getOddValue(row?.instantHome, ref?.initialHome)),
      getOddValue(row?.instantHandicap, ref?.initialHandicap),
      format(getOddValue(row?.instantAway, ref?.initialAway)),
    ];
    early = [
      format(getOddValue(row?.initialHome, ref?.initialHome)),
      getOddValue(row?.instantHandicap, ref?.initialHandicap),
      format(getOddValue(row?.initialAway, ref?.initialAway)),
    ];
  }

  const trends = isHalf
    ? {
        liveLeftTrend: hook.homeHandicapHalfTrend,
        liveRightTrend: hook.awayHandicapHalfTrend,
        compareLeftTrend: hook.homeHandicapHalfTrend,
        compareRightTrend: hook.awayHandicapHalfTrend,
      }
    : {
        liveLeftTrend: resolveOddsTrend(row?.initialHomeTrend, row?.initialHomeTrendOld),
        liveRightTrend: resolveOddsTrend(row?.initialAwayTrend, row?.initialAwayTrendOld),
        compareLeftTrend: resolveOddsTrend(row?.initialHomeTrend, row?.initialHomeTrendOld),
        compareRightTrend: resolveOddsTrend(row?.initialAwayTrend, row?.initialAwayTrendOld),
      };

  return { live, compare, early, trends };
}

function overUnderBlock(row, ref, format, isHalf, hook) {
  const lineRef = ref?.instantHandicap ?? ref?.instantOverUnder;

  const live = [
    format(row?.instantOver),
    getOddValue(row?.instantHandicap, null),
    format(row?.instantUnder),
  ];

  let compare;
  let early;
  if (isHalf) {
    compare = [
      format(getOddValue(row?.instantOver, ref?.instantOver ?? ref?.initialOver)),
      getOddValue(row?.instantHandicap, lineRef),
      format(getOddValue(row?.instantUnder, ref?.instantUnder ?? ref?.initialUnder)),
    ];
    early = [
      format(getOddValue(row?.initialOver, ref?.initialOver)),
      getOddValue(row?.instantHandicap, lineRef),
      format(getOddValue(row?.initialUnder, ref?.initialUnder)),
    ];
  } else {
    compare = [
      format(getOddValue(row?.instantOver, ref?.initialOver)),
      getOddValue(row?.instantHandicap, lineRef),
      format(getOddValue(row?.instantUnder, ref?.initialUnder)),
    ];
    early = [
      format(getOddValue(row?.initialOver, ref?.initialOver)),
      getOddValue(row?.instantHandicap, lineRef),
      format(getOddValue(row?.initialUnder, ref?.initialUnder)),
    ];
  }

  const trends = isHalf
    ? {
        liveLeftTrend: hook.overHalfTrend,
        liveRightTrend: hook.underHalfTrend,
        compareLeftTrend: hook.overHalfTrend,
        compareRightTrend: hook.underHalfTrend,
      }
    : {
        liveLeftTrend: resolveOddsTrend(row?.initialOverTrend, row?.initialOverTrendOld),
        liveRightTrend: resolveOddsTrend(row?.initialUnderTrend, row?.initialUnderTrendOld),
        compareLeftTrend: resolveOddsTrend(row?.initialOverTrend, row?.initialOverTrendOld),
        compareRightTrend: resolveOddsTrend(row?.initialUnderTrend, row?.initialUnderTrendOld),
      };

  return { live, compare, early, trends };
}

function europeBlock(row, ref, format, isHalf, hook) {
  const live = [
    format(row?.instantHome),
    format(row?.instantDraw),
    format(row?.instantAway),
  ];
  const compare = [
    format(getOddValue(row?.instantHome, ref?.instantHome ?? ref?.initialHome)),
    format(getOddValue(row?.instantDraw, ref?.instantDraw ?? ref?.initialDraw)),
    format(getOddValue(row?.instantAway, ref?.instantAway ?? ref?.initialAway)),
  ];
  const early = [
    format(getOddValue(row?.initialHome, ref?.initialHome)),
    format(getOddValue(row?.initialDraw, ref?.initialDraw)),
    format(getOddValue(row?.initialAway, ref?.initialAway)),
  ];

  const trends = isHalf
    ? {
        liveHomeTrend: hook.homeEuropeHalfTrend,
        liveDrawTrend: hook.drawHalfTrend,
        liveAwayTrend: hook.awayEuropeHalfTrend,
        compareHomeTrend: hook.homeEuropeHalfTrend,
        compareDrawTrend: hook.drawHalfTrend,
        compareAwayTrend: hook.awayEuropeHalfTrend,
      }
    : {
        liveHomeTrend: resolveOddsTrend(row?.initialHomeTrend, row?.initialHomeTrendOld),
        liveDrawTrend: resolveOddsTrend(row?.initialDrawTrend, row?.initialDrawTrendOld),
        liveAwayTrend: resolveOddsTrend(row?.initialAwayTrend, row?.initialAwayTrendOld),
        compareHomeTrend: resolveOddsTrend(row?.initialHomeTrend, row?.initialHomeTrendOld),
        compareDrawTrend: resolveOddsTrend(row?.initialDrawTrend, row?.initialDrawTrendOld),
        compareAwayTrend: resolveOddsTrend(row?.initialAwayTrend, row?.initialAwayTrendOld),
      };

  return { live, compare, early, trends };
}

export function buildOddsTripleBlock({
  match,
  isAll,
  filterHandicapOdds,
  filterOverUnderOdds,
  filterEuropeOdds,
  filterHandicapHalfOdds,
  filterOverUnderHalfOdds,
  filterEuropeHalfOdds,
  bookmarkerExtend,
  odds,
}) {
  const format = (v) => formatOddsByBookmarkerExtend(v, bookmarkerExtend);
  const ref = referenceRows(match, isAll);

  return {
    hdp: handicapBlock(filterHandicapOdds, ref.hdp, format, false, odds),
    ou: overUnderBlock(filterOverUnderOdds, ref.ou, format, false, odds),
    x12: europeBlock(filterEuropeOdds, ref.eu, format, false, odds),
    hdpHt: handicapBlock(filterHandicapHalfOdds, ref.hdpHt, format, true, odds),
    ouHt: overUnderBlock(filterOverUnderHalfOdds, ref.ouHt, format, true, odds),
    x12Ht: europeBlock(filterEuropeHalfOdds, ref.euHt, format, true, odds),
  };
}
